// 引入 axios
import axios from "axios";

let BASEURL = 'http://www.jeegarlift.com:80/prod-api/portal';
const IMAGE_URL = "http://www.jeegarlift.com:80/prod-api"

//传送json格式的get请求
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${BASEURL}${url}`,
        data: params,
    })
}
export const imageTran = (path) => IMAGE_URL + path
